import classNames from 'classnames'

import { ICON_HEIGHT_20, IconNG } from '../../../../Icon'

import * as styles from './TrackingStatusIcon.module.css'

import ErrorIcon from '../../../../../icons/unique/error-color.svg'
import SuccessIcon from '../../../../../icons/unique/success.svg'

function TrackingStatusIcon({
  completed,
  current,
  isError,
  isLast,
  isLastCompletedBeforeError,
}) {
  const lineMods = {
    [styles.lineActive]: completed && !isError && !isLastCompletedBeforeError,
    [styles.lineError]: isLastCompletedBeforeError,
  }

  return (
    <div className={styles.TrackingStatusIcon}>
      {completed || isError ? (
        <IconNG
          Icon={isError ? ErrorIcon : SuccessIcon}
          svgSize={ICON_HEIGHT_20}
        />
      ) : (
        <div
          className={classNames(styles.icon, {
            [styles.iconActive]: current,
          })}
        />
      )}

      {!isLast ? <div className={classNames(styles.line, lineMods)} /> : null}
    </div>
  )
}

export default TrackingStatusIcon
